import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { CanDeactivateComponent } from './types';
import { CanDeactivateNotification } from './can-deactivate.notification.service';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements CanDeactivate<any> {
  constructor(private canDeactivateService: CanDeactivateNotification) {}

  canDeactivate(component: CanDeactivateComponent): boolean {
    if (typeof component.canDeactivate === 'function' && !component.canDeactivate()) {
      return this.canDeactivateService.canDeactivate();
    }
    return true;
  }
}
